export function optionProvider() {
    return {
        headers: {
            'Content-Type': 'application/json'
        }
    };
}
